// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"y5-z","dimensionLabel":"z5-z","styleChooserControlWrapper":"A5-z","styleChooserControl":"B5-z","disabled":"C5-z","giftCard":"D5-z","styleChooserText":"E5-z"};